import { ProductsDetailedProvider } from './productsDetailedContext'
import { ProductsIncome } from './productsIncome'

export function ProductsDetailedInformations() {
  return(
      <ProductsDetailedProvider>

          <ProductsIncome />
          
      </ProductsDetailedProvider>
  )
}
